import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const usePaymentStyles = makeStyles({
    root: {},
    tempusContainer: {
        width: `100%`,
        ...shorthands.padding(0)
    },
    tempusFrameContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalM,
        ...shorthands.padding(tokens.spacingHorizontalXXL)
    },
    tempus: {
        flexGrow: 1,
        height: '285px',
        ...shorthands.border(0)
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalM,
        backgroundColor: tokens.colorNeutralBackground3
    },
    note: {
        color: tokens.colorNeutralForeground4
    },
    safetySection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: tokens.colorPaletteBlueBackground2,
        columnGap: tokens.spacingVerticalM,
        ...shorthands.borderRadius(tokens.borderRadiusXLarge, tokens.borderRadiusXLarge, 0, 0),
        ...shorthands.padding(tokens.spacingHorizontalXXL)
    },
    errorBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#FFF1F1',
        columnGap: tokens.spacingVerticalM,
        ...shorthands.borderRadius('16px'),
        ...shorthands.border('0')
    }
});
